import {
  Backdrop, Typography,
} from '@mui/material';
import styled from 'styled-components';

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
`;

const TopButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  justify-content: space-between;
`;

const ContentContainer = styled.div`
  width: 100%;
  max-width: 720px;
`;

const MasterAccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
  width: fit-content;
`;

const SelectableRow = styled.div`
  cursor: pointer;
  padding: ${({ theme }) => theme.spacing(1)};
  border-top: 1px solid ${({ theme }) => theme.palette.divider};
  &:hover {
    background-color: ${({ theme }) => theme.palette.action.hover};
  }
`;

const HeadingRow = styled.div`
  padding-left: ${({ theme }) => theme.spacing(1)};
  padding-right: ${({ theme }) => theme.spacing(1)};
`;

const Header = styled(Typography)`
  && {
    margin-bottom: ${({ theme }) => theme.spacing(1)};
  }
`;

const StyledBackdrop = styled(Backdrop)`
  z-index: ${({ theme }) => theme.zIndex.drawer + 1};
`;

export { MasterAccessContainer,
  Header,
  SelectableRow,
  StyledBackdrop,
  PageContainer,
  ContentContainer,
  TopButtonsContainer,
  HeadingRow };
